import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { message } from "antd";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getPractitionerDetail = createAsyncThunk(
  "practitionerDetail/getPractitionerDetail",
  async (counsellorId, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${API_BASE_URL}/counsellor?counsellorId=${counsellorId}`,
        {
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );

      if (response.data.status === false && response.data.response_code === 0) {
        return { status: "success", data: response.data.payload };
      } else {
        message.error(response.data.response_message || "Failed to fetch practitioner details");
        return rejectWithValue(response.data.response_message || "Failed to fetch practitioner details");
      }
    } catch (error) {
      const errorMessage = error.response?.data?.response_message || error.message || "Failed to fetch practitioner details";
      message.error(errorMessage);
      return rejectWithValue(errorMessage);
    }
  }
);

export const updatePractitionerStatus = createAsyncThunk(
  "practitionerDetail/updatePractitionerStatus",
  async ({ pcUserId, status }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.patch(
        `${API_BASE_URL}/user/${pcUserId}`,
        { status },
        {
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.status === false && response.data.response_code === 0) {
        message.success(`Practitioner status updated to ${status}`);
        return { status: "success", data: response.data.payload, newStatus: status };
      } else {
        message.error(response.data.response_message || "Failed to update practitioner status");
        return rejectWithValue(response.data.response_message || "Failed to update practitioner status");
      }
    } catch (error) {
      const errorMessage = error.response?.data?.response_message || error.message || "Failed to update practitioner status";
      message.error(errorMessage);
      return rejectWithValue(errorMessage);
    }
  }
);

const practitionerDetailSlice = createSlice({
  name: "practitionerDetail",
  initialState: {
    data: null,
    loading: false,
    error: null,
    updating: false,
    updateError: null,
  },
  reducers: {
    clearPractitionerDetail: (state) => {
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPractitionerDetail.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPractitionerDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
      })
      .addCase(getPractitionerDetail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Update Practitioner Status
      .addCase(updatePractitionerStatus.pending, (state) => {
        state.updating = true;
        state.updateError = null;
      })
      .addCase(updatePractitionerStatus.fulfilled, (state, action) => {
        state.updating = false;
        // Update the status in the current data
        if (state.data) {
          state.data.status = action.payload.newStatus;
        }
      })
      .addCase(updatePractitionerStatus.rejected, (state, action) => {
        state.updating = false;
        state.updateError = action.payload;
      });
  },
});

export const { clearPractitionerDetail } = practitionerDetailSlice.actions;
export default practitionerDetailSlice.reducer;